// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ts-0";